var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtmFphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-DTMF_phone"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DTMF_phone",
    "data-name": "DTMF phone",
    clipPath: "url(#clip-DTMF_phone)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DTMF_phone-2",
    "data-name": "DTMF phone",
    transform: "translate(22 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M361.924,114.9c.007,0,.015.007.023.007h.046Z",
    transform: "translate(-35.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M444.338,59.454l.007-.024c-.14-.046-18.878-6.947-34.819-11.3-22.222-6.04-55.062-10.4-88.455-13.421-33.351-2.993-66.989-4.536-90.12-4.536s-56.768,1.543-90.126,4.536C107.433,37.721,74.6,42.086,52.378,48.134c-15.943,4.349-34.7,11.25-34.835,11.3l.007.024C7.253,62.958.007,73.394,0,85.428c0,.783.035,1.6.1,2.426v-.023l7.324,90.235v.031a28.23,28.23,0,0,0,8.163,17.8,23.912,23.912,0,0,0,16.787,7.04h72.948a23.9,23.9,0,0,0,16.612-6.861,28.109,28.109,0,0,0,8.3-17.477l3.693-36.852v-.023a3.273,3.273,0,0,1,.924-1.978,3.6,3.6,0,0,1,2.3-1.108l.062-.008c.007,0,3.63-.348,9.674-.884,18.1-1.6,57.923-4.784,84.069-4.776,17.4,0,40.962,1.4,60.035,2.822,9.541.713,17.983,1.427,24.033,1.954s9.666.884,9.674.884l.063.008a3.6,3.6,0,0,1,2.3,1.108,3.275,3.275,0,0,1,.924,1.978v.023l3.7,36.868v-.024a28.08,28.08,0,0,0,8.282,17.484,23.9,23.9,0,0,0,16.619,6.861h72.926a23.958,23.958,0,0,0,16.8-7.04,28.194,28.194,0,0,0,8.163-17.8l.006-.031L461.8,87.83v-.023c.063-.807.091-1.6.091-2.38C461.894,73.394,454.641,62.966,444.338,59.454ZM440.4,85.715l-.714-.023.714.031-7.323,90.212v-.024a3.381,3.381,0,0,1-1.028,2.171,3.583,3.583,0,0,1-2.539,1.039H356.583a3.593,3.593,0,0,1-2.512-1.008A3.354,3.354,0,0,1,353.043,176v-.024l-3.7-36.867v.023a28.165,28.165,0,0,0-7.519-16.693,24.16,24.16,0,0,0-15.3-7.537c-.616-.054-59.085-5.737-95.576-5.753-36.5.016-94.96,5.7-95.575,5.753a24.165,24.165,0,0,0-15.3,7.537,28.176,28.176,0,0,0-7.519,16.693v-.023l-3.693,36.867a3.361,3.361,0,0,1-1.035,2.133,3.593,3.593,0,0,1-2.512,1.008H32.371a3.569,3.569,0,0,1-2.518-1.032,3.439,3.439,0,0,1-1.036-2.178l.007.024L21.5,85.693v-.024l-.014-.24a3.471,3.471,0,0,1,2.462-3.265l.161-.054.189-.07s1.111-.412,3.064-1.1c5.848-2.086,19.131-6.683,30.148-9.684,19.879-5.45,52.32-9.894,85.048-12.809,32.763-2.946,66.079-4.458,88.391-4.458s55.622,1.512,88.385,4.458c32.728,2.915,65.177,7.358,85.055,12.809,7.331,2,15.7,4.714,22.166,6.916,3.239,1.1,6.008,2.07,7.967,2.768s3.056,1.1,3.064,1.1l.189.07.175.054a3.462,3.462,0,0,1,2.456,3.265l-.008.286v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M150.014,114.906h.047c.008,0,.015-.007.023-.007Z",
    transform: "translate(-14.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M331.1,224.882a282.928,282.928,0,0,1-11.013-41.761c-.924-5.14-1.481-9.2-1.807-11.924-.164-1.357-.265-2.388-.326-3.047l-.061-.706-.013-.147-.741-10.987H255.3v39.7H206.6v-39.7H144.761l-.747,10.994h.007c-.054.783-1.99,25.726-13.771,59.166-11.808,33.518-33.366,75.465-72.743,111.053L53.544,341.1V458.67c.014,12.8,9.077,23.144,20.294,23.16H388.062c11.217-.016,20.281-10.358,20.294-23.16V341.1l-3.961-3.574C364.393,301.37,342.781,258.656,331.1,224.882ZM163.534,180.128h22.2v39.7h90.442v-39.7h22.2a300.613,300.613,0,0,0,13.316,53.5c12.277,35.541,34.874,80.372,75.8,118.845v105.54H74.416V352.472c40.927-38.473,63.524-83.3,75.8-118.845A301.771,301.771,0,0,0,163.534,180.128Z",
    transform: "translate(0 -6.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M256,426.378a79.4,79.4,0,1,0-79.4-79.4A79.489,79.489,0,0,0,256,426.378Zm0-145.555a66.22,66.22,0,1,1-46.769,19.4A65.927,65.927,0,0,1,256,280.823Z",
    transform: "translate(-25.053 -6.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M256,386.681a39.7,39.7,0,1,0-39.7-39.7A39.7,39.7,0,0,0,256,386.681Z",
    transform: "translate(-25.053 -4.563)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtmFphone);
export default __webpack_public_path__ + "static/media/DTMF phone.08aaa552f07c20da389d22f9a0ecf72f.svg";
export { ForwardRef as ReactComponent };